import React from 'react'

import Header from '../../../components/Turkey/Header/Header'
import Slider from '../../../components/Turkey/Slider/Slider'
import OurActivities from '../../../components/Turkey/OurActivities/OurActivities'
import OurProducts from '../../../components/Turkey/OurProducts/OurProducts'
import AboutUs from '../../../components/Turkey/AboutUs/AboutUs'
import Promotion from '../../../components/Turkey/Promotion/Promotion'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import Footer from '../../../components/Turkey/Footer/Footer'

export default function Home() {
  return (
    <div>
      <Header page={'home'} />
      <Slider />
      <OurActivities />
      <OurProducts />
      <AboutUs />
      <Promotion />
      <LogoPartner />
      <Footer />
    </div>
  )
}
